import * as PredictionConfigClient from '../clients/PredictionConfigClient'

export default class PredictionConfig {
  constructor (name) {
    this.name = name
    this.raceProperties =
    [
      {
        "propertyName": "location"
      },
      {
        "propertyName": "class"
      },
      {
        "propertyName": "raceType"
      },
      {
        "propertyName": "isHandicap"
      }
    ]
    this.percentiles = {},
    this.excludedTags = [],
    this.excludeOutsiders = true,
    this.scoreType = 'marginScore '
    this.useExtremeScoresOnly = {},
    this.threshold = {
      number: undefined
    }
    this.thresholdWeighting = {
      threshold : undefined,weight: undefined
    }
    this.allow0ScoreForPropertyValues = true
  }
  load() {
    return new Promise ((resolve, reject) => {
      PredictionConfigClient.getPredictionConfig(this.name)
      .then(config => {
        Object.keys(config).forEach(key => {
          this[key] = config[key]
        })
        this.excludedTagsString = this.excludedTags.join(",")
        resolve(config)
      })
    })
  }
  save(password) {
    console.log("Saving predictionConfig for " + this.name)
    return new Promise ((resolve, reject) => {
      //TODO validation
      this.useExtremeScoresOnly.top = this.useExtremeScoresOnly.top * 1 || undefined
      this.useExtremeScoresOnly.bottom = this.useExtremeScoresOnly.bottom * 1 || undefined
      if (this.excludedTagsString) this.excludedTags = this.excludedTagsString.split(',')
      this.scoreType = this.scoreType.trim()
      this.name = this.name.trim()
      var validatedRaceProperties = []
      for (var i = 0; i < this.raceProperties.length; i++) {
        this.raceProperties[i].propertyName = this.raceProperties[i].propertyName.trim()
        if (this.raceProperties[i].propertyName !== "") validatedRaceProperties.push(this.raceProperties[i])
      }
      this.raceProperties = validatedRaceProperties
      PredictionConfigClient.updatePredictionConfig(this.name, this, password)
      .then(response => {
        resolve(response)
      })
      .catch (err => {
        reject(err)
      })
    })
  }

}
